<template>
  <div class="adminLogin">
    <form class="form-signin mt-4" @submit.prevent="login">
      <h1 class="h3 mb-3 font-weight-normal mt-4">請先登入</h1>
      <label for="inputEmail" class="sr-only">Email address</label>
      <input type="email" id="inputEmail" class="form-control"
        placeholder="Email address" required v-model="userName">
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control"
        placeholder="Password" required v-model="password">
      <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me"> Remember me
        </label>
      </div>
      <button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
      <p class="mt-5 mb-3 text-muted">&copy; 2017-2019</p>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase/app';

const auth = firebase.auth();

export default {
  name: 'Admin_login',
  data() {
    return {
      userName: '',
      password: '',
    };
  },
  methods: {
    login() {
      this.$store.commit('LOADINGCHANGE', true);
      // sign in
      auth.signInWithEmailAndPassword(this.userName, this.password).then((response) => {
        // get idToken
        response.user.getIdToken().then((idToken) => {
          // post token to set session
          this.axios.post(`${process.env.VUE_APP_APIURL}/api/login`, { idToken })
            .then((res) => {
              // console.log(res.data);
              if (res.data.success) {
                this.$store.commit('UPDATEUSER', res.data.userInfo);
                this.userName = '';
                this.password = '';
                this.$store.dispatch('updateMessage', {
                  message: '登入成功',
                  status: 'success',
                });
                if (!res.data.userInfo.emailVerified) {
                  this.$store.dispatch('updateMessage', {
                    message: '請至信箱驗證並繼續購物',
                    status: 'error',
                  });
                  // this.$router.push('/account/accountInfo');
                }
              }
              this.$store.commit('OPENLOGINBOX', false);
              this.$store.commit('LOADINGCHANGE', false);
            });
        });
      }).catch((err) => {
        if (err.code === 'auth/user-not-found') {
          this.$store.dispatch('updateMessage', {
            message: '查無此用戶，請再次確認帳號密碼',
            status: 'error',
          });
        }
        if (err.code === 'auth/wrong-password') {
          this.$store.dispatch('updateMessage', {
            message: '使用者帳號或密碼錯誤',
            status: 'error',
          });
        }
        if (err.code === 'auth/invalid-email') {
          this.$store.dispatch('updateMessage', {
            message: '請輸入正確的 email 格式',
            status: 'error',
          });
        }
        setTimeout(() => {
          this.$store.commit('LOADINGCHANGE', false);
        }, 500);
      });
    },
    setAdmin() {
      this.axios.post(`${process.env.VUE_APP_APIURL}/api/admin/user`).then((response) => {
        this.$store.dispatch('updateMessage', {
          status: response.data.success ? 'success' : 'error',
          message: response.data.message,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
